import * as React from "react";

interface Props {
  size?: number;
  color?: string;
}

const BanIconV1 = ({ size = 18, color = "currentColor" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="9" />
    <line x1="5.7" y1="5.7" x2="18.3" y2="18.3" />
  </svg>
);

export default BanIconV1;
